import { defaultIconProps, IconProps } from './IconProps';

export const IconMicrosoft: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path d="M19.2563 5.41664H5.41672V19.2591H19.2592V5.41664H19.2563Z" fill="#F25022" />
    <path d="M34.5833 5.41664H20.7408V19.2591H34.5833V5.41664Z" fill="#7FBA00" />
    <path d="M19.2563 20.7408H5.41672V34.5833H19.2592V20.7408H19.2563Z" fill="#00A4EF" />
    <path d="M34.5833 20.7408H20.7408V34.5833H34.5833V20.7408Z" fill="#FFB900" />
  </svg>
);

IconMicrosoft.defaultProps = defaultIconProps;
